import React from "react";
import { Scale } from "lucide-react";

export function EmptyState({ icon: Icon = Scale, title, description, action, testid }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center rounded-lg border border-dashed border-slate-200 bg-white py-16 px-6 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-navy/5 text-navy">
        <Icon className="h-7 w-7" strokeWidth={1.5} />
      </div>
      <h3 className="font-display text-2xl text-navy">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function LoadingState({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center py-20 text-muted-foreground">
      <div className="h-5 w-5 animate-spin rounded-full border-2 border-navy border-t-transparent" />
      <span className="ml-3 text-sm">{label}</span>
    </div>
  );
}
